import React from 'react'
import Header from '../components/Header'
import styled from 'styled-components'
import { Button } from '../components/stylesComponents' // styles used for shared styles
import ReactGA from 'react-ga'

const Texth4 = styled.h4`
  max-width: 50%;
  @media (max-width: 768px) {
    max-width: 90%;
  }
`

const EmailSubmitted = () => {
  return (
    <>
      <Header title="Waitlist" />
      <div className="App">
        <h1>You're on the waitlist!</h1>
        <Texth4>
          Tell us a little more about yourself to get started sooner
        </Texth4>
        <Button
          href="/waitlist"
          onClick={() => {
            ReactGA.event({
              category: 'Navigation',
              action: 'Click',
              label: 'Get Started Sooner',
            })
          }}
        >
          Get Started Sooner
        </Button>
      </div>
    </>
  )
}
export default EmailSubmitted
